<!--  -->
<template>
	<div class="Box">
		<el-dialog :title="title" :close-on-click-modal="false" :visible.sync="RechargeFlag" width="80%"
			:before-close="addClose">
			<el-card class="box-card">
				<h1 style="margin-bottom: 20px; margin-left: 120px">{{ localParamsMovie.movie_Name }}</h1>
				<div style="display: flex;" v-if="!islook">
					<h1 style="margin-bottom: 20px; margin-left: 120px">充值模版</h1>
					<img src="../../../../assets/帮助.png" @mouseover="indicateShow = true"
						@mouseleave="indicateShow = false"
						style="width: 20px;height: 20px;cursor: pointer;margin-left: 20px;" alt="">
				</div>
				<div class="Left">
					<el-form  ref="form" :model="form" label-width="80px" :rules="ruless">
						<el-form-item v-if="!islook" label="模板说明" style="margin-left: 120px" prop="name">
							<el-input v-model="form.name" placeholder="请输入模板说明" style="width: 50%" clearable></el-input>

						</el-form-item>
						<el-form-item v-if="!islook" label="标签" style="margin-left: 120px">
							<el-select v-model="form.recharge_tag" placeholder="请选择标签">
								<!-- <el-option v-for="dict in recharge_tagList" :key="dict.id" :label="dict.name" :value="dict.id" /> -->
								<el-option label="默认" :value="0"></el-option>
								<el-option label="大额" :value="1"></el-option>
								<el-option label="小额" :value="2"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item v-if="!islook" label="充值状态" :label-width="formLabelWidth" prop="status" style="margin-left: 100px">
							<el-radio-group v-model="form.is_open">
								<el-radio :label="0">不区分</el-radio>
								<el-radio :label="1">区分</el-radio>
								<!-- <el-radio :label="2">奇偶数</el-radio> -->
							</el-radio-group>
						</el-form-item>
						<div style="display: flex;">
							<el-form-item label="" :label-width="formLabelWidth" prop="status">
								<div style="display: flex">
									<el-card class="box-card" style="background-color: #EEEEEE;">
										<div slot="header" class="clearfix" style="position: relative;">
											<span>充值档位</span>

											<!-- <i class="el-icon-info" style="position: absolute;left: 62px;top: 13px;width: 30px;height: 30px;"></i> -->
											<el-button v-if="form.is_open == 1" style="float: right; padding: 3px 0"
												type="text">{{ form.is_open
													== 2 ? '奇数' : '已充值' }}</el-button>
										</div>
										<div class="btnAdDanjuitem" v-for="(item, index) in DanjuList" :key="index"
											v-if="DanjuList">
											<div class="left" v-if="item.description">
												<!-- <div class="left_top"
													style="margin-top: 5px;font-size: 20px;font-weight: bold;color: #fff;">
													解锁本剧<span style="color: #f9da63;">全集</span></div> -->
												<div class="left_btn" style="color: #f7d5dd;">{{
													item.description }}</div>

											</div>
											<div class="left" v-else>
												<div class=""
													style="margin-top: 14px;font-size: 20px;font-weight: bold;color: #fff;">
													解锁本剧 <span>全集</span></div>

											</div>
											<div class="right">¥<span style="font-weight: bold;">{{ item.money }}</span>
											</div>
											<div style="width: 100%; height: 10px;position: absolute;">
												<i style="position: absolute; bottom: -55px; right: 8px"
													class="el-icon-edit" @click="UpdateitemDan(item, index)"></i>
												<i style="position: absolute; bottom: -55px; right: 32px"
													@click="deleteItemDan(index)" class="el-icon-delete"></i>
											</div>
											<div class="right_jiao">
												<div class="jiao" style="" v-if="item.goods_mark_txt">
													{{ item.goods_mark_txt }}
												</div>
											</div>
										</div>
										<!-- <div class="btnAdDanju" @click="DialogDan" v-if="DanjuList.length == 0">
											<i class="el-icon-plus"></i>
										
										</div> -->
										<div style="display: flex; justify-content: space-between; flex-wrap: wrap;">
											<draggable v-model="CZOne" :options="{ animation: 300 }"
												style="display: flex;justify-content: space-between; flex-wrap: wrap;width: 400px;">
												<div class="btnAd" v-for="(item, index) in CZOne" :key="index"  style="cursor:move;">
													<div class="btnAd_wai"
														:class="{ 'white-background': item.recharge_type === 0, 'black-background': item.recharge_type === 1 }">
														<div class="price">¥ {{ item.money }}</div>
														<div>
															<div style="position: relative"
																v-if="item.recharge_type == 0">
																<div class="bi">{{ (item.money * 100).toFixed(0)
																	}}k币<span style="color: #ec915f;" v-if="item.free_balance > 0">+{{
																		item.free_balance ?
																			item.free_balance : 0
																		}}k币</span></div>
																<div class="dingBtn" v-if="item.goods_mark_txt"
																	style="background-color: #ed6c34;">{{
																		item.goods_mark_txt }}</div>
															</div>
															<div v-else style="position: relative">
																<div class="bi">{{ item.description }}</div>
																<div class="dingBtn" v-if="item.goods_mark_txt"
																	style="background-color: #ed6c34;">{{
																		item.goods_mark_txt }}</div>
															</div>
														</div>

														<div>
															<!-- <div class="song">{{item.footer_mark_txt?item.footer_mark_txt:""}}</div> -->
															<div class="song" v-if="item.recharge_type == 0"
															style="background-color: #fde2e1;color: #d24757;font-weight: bold;">
																{{ (item.footer_mark_txt && item.footer_mark_txt !=
																	undefined)
																	? item.footer_mark_txt : "" }}</div>
															<div class="song"
															style="background-color: #fc5e5d;color: #fff;font-weight: bold;" v-else>{{
																	(item.footer_mark_txt
																		&& item.footer_mark_txt != undefined) ?
																		item.footer_mark_txt
																		:
																""
																}}</div>
														</div>
														<div style="width: 100%; height: 10px; position: relative;cursor:pointer;"
															v-if="item.footer_mark_txt">
															<i style="position: absolute; bottom: -12px; right: 5px;color: #000;"
																class="el-icon-edit"
																@click="Updateitem(item, index)"></i>
															<i style="position: absolute; bottom: -12px; right: 28px;color: #000;"
																@click="deleteItem(index)" class="el-icon-delete"></i>
														</div>
														<div style="width: 100%; height: 10px; position: relative;cursor:pointer;"
															v-else>
															<i style="position: absolute; bottom: -40px; right: 5px;color: #000;"
																class="el-icon-edit"
																@click="Updateitem(item, index)"></i>
															<i style="position: absolute; bottom: -40px; right: 28px;color: #000;"
																@click="deleteItem(index)" class="el-icon-delete"></i>
														</div>
													</div>


												</div>
												<div class="btnAds" @click="Dialog"
													style="user-drag: none; -webkit-user-drag: none;">
													<i class="el-icon-plus"></i>
												</div>
											</draggable>

										</div>
										<!-- <div class="btn">立即充值</div> -->
									</el-card>
								</div>
							</el-form-item>
							<el-form-item label="" :label-width="formLabelWidth" prop="status">
								<el-card class="box-card" v-if="form.is_open != 0" style="background-color: #EEEEEE;">
									<div slot="header" class="clearfix">
										<span>充值档位</span>
										<el-button style="float: right; padding: 3px 0" type="text">{{ form.is_open == 2
											? '偶数' : '未充值' }}</el-button>
									</div>
									<div class="btnAdDanjuitem" v-for="(item, index) in DanjuListTwo" :key="index"
										v-if="DanjuListTwo">
										<div class="left" v-if="item.description">
											<!-- <div class="left_top"
												style="margin-top: 5px;font-size: 20px;font-weight: bold;color: #fff;">
												解锁本剧<span style="color: #f9da63;">全集</span></div> -->
											<div class="left_btn" style="color: #f7d5dd;">{{
												item.description }}</div>

										</div>
										<div class="left" v-else>
											<div class=""
												style="margin-top: 14px;font-size: 20px;font-weight: bold;color: #fff;">
												解锁本剧 <span>全集</span></div>

										</div>
										<div class="right">¥<span style="font-weight: bold;">{{ item.money }}</span>
										</div>
										<div style="width: 100%; height: 10px;position: absolute;">
											<i style="position: absolute; bottom: -55px; right: 8px"
												class="el-icon-edit" @click="UpdateitemDanTwo(item, index)"></i>
											<i style="position: absolute; bottom: -55px; right: 32px"
												@click="deleteItemDanTwo(index)" class="el-icon-delete"></i>
										</div>
										<div class="right_jiao">
											<div class="jiao" style="" v-if="item.goods_mark_txt">
												{{ item.goods_mark_txt }}
											</div>
										</div>
									</div>
									<!-- <div class="btnAdDanju" @click="DialogDanTwo" v-if="DanjuListTwo.length == 0">
										<i class="el-icon-plus"></i>
										
									</div> -->
									<div style="display: flex; justify-content: space-between; flex-wrap: wrap">
										<draggable v-model="CZTwo" :options="{ animation: 300 }"
											style="display: flex;justify-content: space-between; flex-wrap: wrap;width: 400px;">
										
										<div class="btnAd" style="cursor:move;" v-for="(item, index) in CZTwo" :key="index">
											<div class="btnAd_wai"
												:class="{ 'white-background': item.recharge_type === 0, 'black-background': item.recharge_type === 1 }">
												<div class="price">¥ {{ item.money }}</div>
												<div>
													<div style="position: relative" v-if="item.recharge_type == 0">
														<div class="bi">{{ (item.money * 100).toFixed(0) }}k币<span style="color: #ec915f;"
																v-if="item.free_balance > 0">+{{ item.free_balance ?
																	item.free_balance : 0
																}}k币</span></div>
														<div class="dingBtn" v-if="item.goods_mark_txt"
															style="background-color: #ed6c34;">{{
																item.goods_mark_txt }}</div>
													</div>
													<div v-else style="position: relative">
														<div class="bi">{{ item.description }}</div>
														<div class="dingBtn" v-if="item.goods_mark_txt"
															style="background-color: #ed6c34;">{{
																item.goods_mark_txt }}</div>
													</div>


												</div>

												<div class="song_box">
													<div class="song" v-if="item.recharge_type == 0"
													style="background-color: #fde2e1;color: #d24757;font-weight: bold;">
														{{ (item.footer_mark_txt && item.footer_mark_txt != undefined) ?
															item.footer_mark_txt : "" }}</div>
													<div class="song"  style="background-color: #fc5e5d;color: #fff;font-weight: bold;"
														v-else>
														{{ (item.footer_mark_txt && item.footer_mark_txt != undefined) ?
															item.footer_mark_txt : "" }}</div>
												</div>
												<div style="width: 100%; height: 10px; position: relative;cursor:pointer;"
													v-if="item.footer_mark_txt">
													<i style="position: absolute; bottom: -12px; right: 5px;color: #000;"
														class="el-icon-edit" @click="UpdateitemTwo(item, index)"></i>
													<i style="position: absolute; bottom: -12px; right: 28px;color: #000;"
														@click="deleteItemTwo(index)" class="el-icon-delete"></i>
												</div>
												<div style="width: 100%; height: 10px; position: relative;cursor:pointer;" v-else>
													<i style="position: absolute; bottom: -40px; right: 5px;color: #000;"
														class="el-icon-edit" @click="UpdateitemTwo(item, index)"></i>
													<i style="position: absolute; bottom: -40px; right: 28px;color: #000;"
														@click="deleteItemTwo(index)" class="el-icon-delete"></i>
												</div>
											</div>

										</div>
										<div class="btnAds" @click="DialogB" style="user-drag: none; -webkit-user-drag: none;">
											<i class="el-icon-plus"></i>
										</div>
										</draggable>
										
									</div>
									<!-- <div class="btn">立即充值</div> -->
								</el-card>
							</el-form-item>
						</div>

						<el-form-item style="margin-left: 70px" v-if="!islook">
							<el-button type="primary" @click="onSubmit">保存</el-button>
							<el-button @click="None">重置</el-button>
						</el-form-item>
					</el-form>
					<div v-show="indicateShow"
						style="width: 600px;height: 450px;position: absolute;top: 0px;left: 240px;">
						<img src="../../../../assets/引导.png" style="width: 600px;height: 450px" alt="">
					</div>
				</div>
				<!-- 弹框 -->
				<el-dialog title="添加" :visible.sync="dialogVisible" width="50%" :before-close="handleClose"
					:close-on-click-modal="false" append-to-body>
					<div class="waiAdd">
						<el-form :model="Yiform" label-width="150px" class="demo-ruleForm" ref="ruleForm"
							:rules="rules">
							<el-form-item label="充值类型" :label-width="formLabelWidth" prop="recharge_type"
								v-if="this.VIP_putong == 2" label-width="150px">
								<el-select v-model="Yiform.recharge_type" placeholder="请选择充值类型"
									@change="handleSelectChange()">
									<el-option v-for="dict in recharge_typeList" :key="dict.id" :label="dict.name"
										:value="dict.id" />

								</el-select>
							</el-form-item>
							<el-form-item label="充值类型" :label-width="formLabelWidth" prop="recharge_type"
								v-if="this.VIP_putong == 1" label-width="150px">
								<el-select v-model="Yiform.recharge_type" placeholder="请选择充值类型"
									@change="handleSelectChange()" disabled="false">
									<el-option v-for="dict in recharge_typeListDan" :key="dict.id" :label="dict.name"
										:value="dict.id" />
								</el-select>
							</el-form-item>
							<el-form-item label="VIP充值金额"
								v-if="this.Yiform.recharge_type == 1"
								:label-width="formLabelWidth" prop="money" :rules="[
									{ required: true, message: '请输入VIP充值金额', trigger: 'blur' },
									{ type: 'number', message: 'VIP充值金额必须为数字', trigger: 'blur' },
									{ validator: validatePositiveNumber, message: 'VIP充值金额必须为正整数', trigger: 'blur' },
									{ validator: validateDecimalPlaces, message: 'VIP充值金额只能有两位小数', trigger: 'blur' }
								]">
								<el-input v-model.number="Yiform.money" step="0.01" type="number" min="0"></el-input>
							</el-form-item>





							<!-- <el-form-item v-if="this.Yiform.recharge_type == 1" label="VIP充值金额" label-width="formLabelWidth"
								prop="money" :rules="[
									{ required: true, message: '请选择VIP充值金额', trigger: 'change' }
								]">
								<el-select v-model="Yiform.money" filterable @change="handleOption(Yiform.money)">
									<el-option v-for="dict in YiformList" :key="dict.id" :label="dict.customField"
										:value="dict.id" />
								</el-select>
							</el-form-item> -->


							<el-form-item v-if="this.Yiform.recharge_type == 1" label="VIP天数"
								:label-width="formLabelWidth" prop="day">
								<el-input v-model="Addday.day"></el-input>
							</el-form-item>

							<!-- <el-form-item v-if="this.Yiform.recharge_type == 1" label="VIP提示语"
								:label-width="formLabelWidth" prop="description" :rules="[
									{ validator: validateMaxLength, message: '提示语不能超过10个字', trigger: 'blur' }
								]">
								<el-input v-model="Yiform.description" placeholder="请输入VIP提示语(不超过10个字)"></el-input>
							</el-form-item> -->
							<el-form-item label="充值金额"
								v-if="this.Yiform.recharge_type == 0 || this.Yiform.recharge_type == 2"
								:label-width="formLabelWidth" prop="money" :rules="[
									{ required: true, message: '请输入充值金额', trigger: 'blur' },
									{ type: 'number', message: '充值金额必须为数字', trigger: 'blur' },
									{ validator: validatePositiveNumber, message: '充值金额必须为正整数', trigger: 'blur' },
									{ validator: validateDecimalPlaces, message: '充值金额只能有两位小数', trigger: 'blur' }
								]">
								<el-input v-model.number="Yiform.money" step="0.01" type="number" min="0"></el-input>
							</el-form-item>
							<el-form-item v-if="this.Yiform.recharge_type == 2" label="提示语"
								:label-width="formLabelWidth" prop="description" :rules="[
									{ validator: validateMaxLength, message: '提示语不能超过10个字', trigger: 'blur' }
								]">
								<el-input v-model="Yiform.description" placeholder="请输入提示语(不超过10个字)"></el-input>
							</el-form-item>
							<el-form-item label="赠送K币" v-if="this.Yiform.recharge_type == 0"
								:label-width="formLabelWidth" prop="free_balance" :rules="[
									{ validator: validatePositiveIntegerOrEmpty, message: '赠送K币必须为正整数', trigger: 'blur' }
								]">
								<el-input v-model.number="Yiform.free_balance"
									placeholder="K币换算单位：1元=100K币，请酌情输入"></el-input>
							</el-form-item>
							<el-form-item label="角标文案" :label-width="formLabelWidth" prop="goods_mark_txt" :rules="[
								{ validator: validateMaxJiaoLength, message: '角标文案不能超过4个字', trigger: 'blur' }
							]" v-if="this.Yiform.recharge_type == 0 || this.Yiform.recharge_type == 1">
								<el-input v-model="Yiform.goods_mark_txt"
									placeholder="请输入角标文案(不超过4个字)，默认展示特惠"></el-input>
							</el-form-item>
							<el-form-item label="角标文案" :label-width="formLabelWidth" prop="goods_mark_txt" :rules="[
								{ validator: validateMaxJiaoLength, message: '角标文案不能超过4个字', trigger: 'blur' }
							]" v-if="this.Yiform.recharge_type == 2">
								<el-input v-model="Yiform.goods_mark_txt" placeholder="请输入角标文案(不超过4个字)"></el-input>
							</el-form-item>
							<el-form-item label="提示文案(底部浮标)" :label-width="formLabelWidth"
								v-if="this.Yiform.recharge_type == 0 || this.Yiform.recharge_type == 1"
								prop="footer_mark_txt" :rules="[
									{ validator: validateMaxLength, message: '提示语不能超过10个字', trigger: 'blur' }
								]">
								<el-input v-model="Yiform.footer_mark_txt"
									:placeholder="this.Yiform.recharge_type == 0 ? '请输入提示文案(底部浮标)(不超过10个字)，默认展示立即充值' : '请输入提示文案(不超过10个字)，默认展示开通会员'"></el-input>
							</el-form-item>
							<el-form-item label="默认选中" :label-width="formLabelWidth" prop="default_value"
								 label-width="150px">
								<el-select v-model="Yiform.default_value" placeholder="请选择是否默认选中"
									@change="handleSelectChange1()">
									<el-option v-for="dict in morenlist" :key="dict.id" :label="dict.name"
										:value="dict.id" />
								</el-select>
							</el-form-item>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
						<el-button @click="dialogVisiblePush">取 消</el-button>
						<el-button type="primary" @click="submitForm">确 定</el-button>
					</span>
				</el-dialog>

			</el-card>

		</el-dialog>
	</div>
</template>

<script>
import { RechargeAPI } from '@/api/popularize/Recharge';
import { processErrors } from '@/utils/errorHandler';
import { VipApi } from '@/api/vipRecharge/index';
import { Session } from '@/utils/storage';
import draggable from "vuedraggable"
export default {
	// props: ['RechargeFlag', 'paramsMovie', 'id'],
	props: ['RechargeFlag', 'paramsMovie', 'id','islook'],
	components: { draggable },
	data() {
		return {
			title: '充值模板',
			formLabelWidth: '',
			states: true,
			show: 0,
			form: {
				recharge_tag: 0,
				is_open: 1,
				// movie_id: '',
				name: '',
				platform_type: 1,
				id: '',
				w_recharge_gear: [], //未充值
				recharge_gear: [], //已充值
			},
			Addday: {
				day:''
			},
			CZOne: [],
			CZTwo: [],
			dialogVisible: false,
			Yiform: {
				description: "1111",
				recharge_type: 0, //是否是vip
				money: '', //充值金额
				free_balance: '', //赠送书币
				goods_mark_txt: '', //提示语
				balance_all: '',
				footer_mark_txt: "",
				default_value:1,//1否 2是
			},
			ruless: {
				name: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
			},
			YiformListAll: [],
			YiformList: [],
			recharge_typeList: [
				{ id: 0, name: '普通充值' },
				{ id: 1, name: 'VIP充值' },
				{ id: 2, name: "整本购" }
			],
			recharge_typeListDan: [
				// { id: 0, name: '普通充值' },
				// { id: 1, name: 'VIP充值' },
				{ id: 2, name: "整本购" }
			],
			morenlist: [
				// { id: 0, name: '普通充值' },
				// { id: 1, name: 'VIP充值' },
				{ id: 1, name: "否" },
				{ id: 2, name: "是" }
			],
			recharge_tagList: [
				{ id: 0, name: '默认' },
				{ id: 1, name: '大额' },
				{ id: 2, name: '小额' },
			],
			rules: {
				recharge_type: [{ required: true, message: '请输入充值类型', trigger: 'blur' }],
				money: [{ required: true, message: '请输入充值金额', trigger: 'blur' }],
				balance: [{ required: true, message: '请输入充值金额', trigger: 'blur' }],
				// moneys: [{ required: true, message: '请输入VIP充值金额', trigger: 'change' }],
			},
			Select: [],
			statesA: 0,
			mobanId: '',
			localParamsMovie: { ...this.paramsMovie },
			DanjuList: [],
			DanjuListTwo: [],
			VIP_putong: 0,
			VIP_update: false,
			indicateShow: false
		};
	},
	methods: {
		indicate() {
			this.indicateShow = !this.indicateShow
		},
		validatePositiveNumber(rule, value, callback) {
			if (value === undefined || value === null) {
				callback(new Error('充值金额不能为空'));
			} else if (!isNaN(value) && value > 0) {
				callback(); // 验证通过
			} else {
				callback(new Error('充值金额必须为正数'));
			}
		},
		validateDecimalPlaces(rule, value, callback) {
			if (value && !/^\d+(\.\d{1,2})?$/.test(value)) {
				callback(new Error('充值金额只能有两位小数'));
			} else {
				callback();
			}
		},
		validatePositiveIntegerOrEmpty(rule, value, callback) {
			if (value === undefined || value === null || value === '') {
				callback(); // 允许为空
			} else if (!Number.isInteger(value) || value < 0) {
				callback(new Error('赠送K币必须为正整数'));
			} else {
				callback(); // 验证通过
			}
		},
		//提示文案
		validateMaxLength(rule, value, callback) {
			if (!value) {
				return callback(); // 直接通过验证
			}

			let byteLen = 0;
			for (let i = 0; i < value.length; i++) {
				const c = value.charCodeAt(i);
				// 单字节加1，中文字符加3
				byteLen += c >= 0 && c <= 255 ? 1 : 3;
			}

			const maxLength = 30; // 最大字符长度
			if (byteLen > maxLength) {
				callback(new Error(`提示文案不能超过 ${maxLength} 个字`));
			} else {
				callback(); // 验证通过
			}
		},

		//角标文案
		validateMaxJiaoLength(rule, value, callback) {

			const maxLength = 4; // 最大字符长度
			if (value && value.length > maxLength) {
				callback(new Error(`角标文案不能超过 ${maxLength} 个字`));
			} else {
				callback(); // 验证通过
			}
		},
		getSelect() {
			let api = RechargeAPI();
			api.Rechargetmpla(this.localParamsMovie.movie_id).then((res) => {
				this.Select = res.data;
			});
		},
		dialogVisiblePush() {
			this.dialogVisible = false
			this.show = 0
			this.$refs.ruleForm.resetFields();
		},
		addClose() {
			this.$emit('RechargeNone');
		},
		Dialog() {
			this.VIP_update = false
			this.VIP_putong = 2
			this.dialogVisible = true;
			this.Yiform = {
				recharge_type: 0, //是否是vip
				money: '', //充值金额
				free_balance: '', //赠送书币
				goods_mark_txt: '', //提示语
				footer_mark_txt: "",
				default_value:1,//1否 2是
				
			};
			this.states = true;
		},
		DialogDan() {
			//点击的是否是单据解锁
			this.VIP_putong = 1
			this.states = true;
			this.dialogVisible = true;
			this.Yiform = {
				recharge_type: 2, //是否是vip
				money: '', //充值金额
				free_balance: '', //赠送书币
				goods_mark_txt: '', //提示语
				footer_mark_txt: "",
				default_value:1,//1否 2是
			};
			this.statesA = 1;
		},
		DialogDanTwo() {
			this.VIP_putong = 1
			this.dialogVisible = true;
			this.Yiform = {
				recharge_type: 2, //是否是vip
				money: '', //充值金额
				free_balance: '', //赠送书币
				goods_mark_txt: '', //提示语
				footer_mark_txt: "",
				default_value:1,//1否 2是
			};
			this.states = false;
		},
		DialogB() {
			this.VIP_update = false
			this.VIP_putong = 2
			this.dialogVisible = true;
			this.Yiform = {
				recharge_type: 0, //是否是vip
				money: '', //充值金额
				free_balance: '', //赠送书币
				goods_mark_txt: '', //提示语
				footer_mark_txt: "",
				default_value:1,//1否 2是

			};
			this.states = false;
		},
		deleteItem(index) {
			this.CZOne.splice(index, 1);
		},
		deleteItemDan(index) {
			this.DanjuList.splice(index, 1);
		},
		deleteItemDanTwo(index) {
			this.DanjuListTwo.splice(index, 1);
		},
		deleteItemTwo(index) {
			this.CZTwo.splice(index, 1);
		},
		UpdateitemDan(item, index) {
			this.VIP_putong = 1
			this.states = true
			this.show = 2;
			Session.set('indexArrDan', index);
			this.dialogVisible = true;
			this.Yiform = item;
			this.Addday = {
				...item,
				money: item.money,
				day: item.day,
				description: item.description,
			};
			this.Yiform = this.Addday;
		},
		UpdateitemDanTwo(item, index) {
			this.states = false
			this.dialogVisible = true;
			this.VIP_putong = 1
			this.show = 2;
			Session.set('indexArrDanTwo', index);

			this.Yiform = item;
			this.Addday = {
				...item,
				money: item.money,
				day: item.day,
				description: item.description,
			};
			this.Yiform = this.Addday;

		},
		Updateitem(item, index) {
			this.states = true
			this.VIP_putong = 2
			this.VIP_update = true
			Session.set('indexArr', index);
			this.dialogVisible = true;
			this.show = 1;
			this.Yiform = item;
			if (item.recharge_type == 1) {
				this.Addday = {
					...item,
					money: item.money,
					day: item.day,
					description: item.description,
				};
				this.Yiform = this.Addday;
				let params = {
					sort: 'money',
					sortType: 'asc',
				};
				const api = VipApi();
				// api
				// 	.getvipList(params)
				// 	.then((res) => {
				// 		if (res.code == 0) {
				// 			// this.YiformList = res.data.data
				// 			this.YiformList = res.data.data.map((item) => ({
				// 				...item, // 保留原始对象的所有属性
				// 				customField: `${item.money}元 = ${item.day}天会员`, // 添加新的 customField 字段
				// 			}));
				// 			this.YiformListAll = res.data.data;
				// 		} else {
				// 			processErrors(res);
				// 		}
				// 	})
				// 	.catch((error) => {
				// 		this.loading = false;
				// 	});
			} else if (item.recharge_type == 0) {
				this.Addday = {
					...item,
					money: item.money,
					day: item.day,
					description: item.description,
				};
				this.Yiform = this.Addday;
			} else {

			}
		},
		UpdateitemTwo(item, index) {
			this.states = false
			this.VIP_putong = 2
			this.VIP_update = true
			Session.set('indexArr', index);
			this.dialogVisible = true;
			this.show = 1;
			this.Yiform = item;
			if (item.recharge_type == 1) {
				this.Addday = {
					...item,
					money: item.money,
					day: item.day,
					description: item.description,
				};
				this.Yiform = this.Addday;
				let params = {
					sort: 'money',
					sortType: 'asc',
				};
				const api = VipApi();
				// api
				// 	.getvipList(params)
				// 	.then((res) => {
				// 		if (res.code == 0) {
				// 			// this.YiformList = res.data.data
				// 			this.YiformList = res.data.data.map((item) => ({
				// 				...item, // 保留原始对象的所有属性
				// 				customField: `${item.money}元 = ${item.day}天会员`, // 添加新的 customField 字段
				// 			}));
				// 			this.YiformListAll = res.data.data;
				// 		} else {
				// 			processErrors(res);
				// 		}
				// 	})
				// 	.catch((error) => {
				// 		this.loading = false;
				// 	});
			} else if (item.recharge_type == 0) {
				this.Addday = {
					...item,
					money: item.money,
					day: item.day,
					description: item.description,
				};
				this.Yiform = this.Addday;
			} else {

			}
		},
		submitForm() {
			// 
			if (this.states == true) {
				// this.show=0
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
					console.log(this.Yiform,'添加的值')
						if (this.Yiform.recharge_type == 0) {

							if (this.show == 0) {
								let money = parseFloat(this.Yiform.money);
								let freeBalance = parseFloat(this.Yiform.free_balance ? this.Yiform.free_balance : 0);
								let objar = {
									...this.Yiform,
									footer_mark_txt: this.Yiform.footer_mark_txt ? this.Yiform.footer_mark_txt : "",
									goods_mark_txt: this.Yiform.goods_mark_txt ? this.Yiform.goods_mark_txt : "",

									balance_all: freeBalance ? (money * 100 + freeBalance).toFixed(0) : (money * 100).toFixed(0), // 保持浮点数运算并格式化为字符串
									balance: (money * 100).toFixed(0), // 保持浮点数运算并格式化为字符串
								};

								this.CZOne.push(objar);

								this.Yiform = {
									recharge_type: 0, //是否是vip
									money: 0, //充值金额
									free_balance: '', //赠送书币
									goods_mark_txt: '', //提示语
									footer_mark_txt: ""
								};
								this.dialogVisible = false;
								this.show = 0;
							} else {
								let money = parseFloat(this.Yiform.money);
								let freeBalance = parseFloat(this.Yiform.free_balance ? this.Yiform.free_balance : 0);
								let objar = {
									...this.Yiform,
									footer_mark_txt: this.Yiform.footer_mark_txt ? this.Yiform.footer_mark_txt : "",
									goods_mark_txt: this.Yiform.goods_mark_txt ? this.Yiform.goods_mark_txt : "",
									balance_all: freeBalance ? (money * 100 + freeBalance).toFixed(0) : (money * 100).toFixed(0), // 保持浮点数运算并格式化为字符串
									balance: (money * 100).toFixed(0), // 保持浮点数运算并格式化为字符串
								};
								let index = Session.get('indexArr');
								this.CZOne[index] = objar;
								this.dialogVisible = false;
								this.show = 0;
							}
						} else if (this.Yiform.recharge_type == 1) {
							if (this.show == 0) {
								console.log('进来了')
								let ar = {
									...this.Yiform,
									footer_mark_txt: this.Yiform.footer_mark_txt ? this.Yiform.footer_mark_txt : "",
									goods_mark_txt: this.Yiform.goods_mark_txt ? this.Yiform.goods_mark_txt : "",
									money: this.Addday.money ? this.Addday.money :  this.Yiform.money,
									day: this.Addday.day ? this.Addday.day : this.Yiform.day,
									description: this.Addday.description ? this.Addday.description : this.Yiform.description ? this.Yiform.description : "全站免费看",
								};

								this.CZOne.push(ar);
								this.dialogVisible = false
								this.show = 0;
							} else {
								let ar = {
									...this.Yiform,
									money: this.Addday.money,
									day: this.Addday.day,
									footer_mark_txt: this.Yiform.footer_mark_txt ? this.Yiform.footer_mark_txt : "",
									goods_mark_txt: this.Yiform.goods_mark_txt ? this.Yiform.goods_mark_txt : "",
									// description: this.Addday.description,
									description: this.Addday.description ? this.Addday.description : "全站免费看",
								};
								let index = Session.get('indexArr');
								this.CZOne[index] = ar;
								this.dialogVisible = false;
								this.show = 0;
							}
						} else {
							if (this.show == 2) {
								let index = Session.get('indexArrDan');
								let objarDan = {
									...this.Yiform,
								};
								this.DanjuList[index] = objarDan
								this.dialogVisible = false;
								this.show = 0;
							} else {
								this.DanjuList.push(this.Yiform)
								this.dialogVisible = false;
								this.show = 0;
							}

						}
					}
				});
			} else if (this.states == false) {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						if (this.Yiform.recharge_type == 0) {
							if (this.show == 0) {
								let money = parseFloat(this.Yiform.money);
								let freeBalance = parseFloat(this.Yiform.free_balance);
								let objar = {
									...this.Yiform,
									footer_mark_txt: this.Yiform.footer_mark_txt ? this.Yiform.footer_mark_txt : "",
									goods_mark_txt: this.Yiform.goods_mark_txt ? this.Yiform.goods_mark_txt : "",
									balance_all: freeBalance ? (money * 100 + freeBalance).toFixed(0) : (money * 100).toFixed(0), // 保持浮点数运算并格式化为字符串
									balance: (money * 100).toFixed(0), // 保持浮点数运算并格式化为字符串
								};

								this.CZTwo.push(objar);
								// this.Yiform = {
								// 	recharge_type: 0, //是否是vip
								// 	money: 0, //充值金额
								// 	free_balance: '', //赠送书币
								// 	goods_mark_txt: '', //提示语
								// 	footer_mark_txt: ""
								// };
								this.dialogVisible = false;
								this.show = 0;
							} else {
								// 	this.Yiform = {
								// 	recharge_type: 0, //是否是vip
								// 	money: 0, //充值金额
								// 	free_balance: '', //赠送书币
								// 	goods_mark_txt: '', //提示语
								// };
								let money = parseFloat(this.Yiform.money);
								let freeBalance = parseFloat(this.Yiform.free_balance);
								let objar = {
									...this.Yiform,
									footer_mark_txt: this.Yiform.footer_mark_txt ? this.Yiform.footer_mark_txt : "",
									goods_mark_txt: this.Yiform.goods_mark_txt ? this.Yiform.goods_mark_txt : "",
									balance_all: freeBalance ? (money * 100 + freeBalance).toFixed(0) : (money * 100).toFixed(0), // 保持浮点数运算并格式化为字符串
									balance: (money * 100).toFixed(0), // 保持浮点数运算并格式化为字符串
								};
								let index = Session.get('indexArr');
								this.CZTwo[index] = objar;
								this.dialogVisible = false;
								this.show = 0;

							}
						} else if (this.Yiform.recharge_type == 1) {

							if (this.show == 0) {
								let ar = {

									...this.Yiform,
									footer_mark_txt: this.Yiform.footer_mark_txt ? this.Yiform.footer_mark_txt : "",
									goods_mark_txt: this.Yiform.goods_mark_txt ? this.Yiform.goods_mark_txt : "",
									money: this.Addday.money ? this.Addday.money :  this.Yiform.money,
									day: this.Addday.day ? this.Addday.day : this.Yiform.day,
									description: this.Addday.description ? this.Addday.description : this.Yiform.description ? this.Yiform.description : "全站免费看",
								
								};
								this.CZTwo.push(ar);

								this.dialogVisible = false;
								this.show = 0;
							} else {
								let ar = {
									...this.Yiform,
									money: this.Addday.money,
									day: this.Addday.day,
									footer_mark_txt: this.Yiform.footer_mark_txt ? this.Yiform.footer_mark_txt : "",
									goods_mark_txt: this.Yiform.goods_mark_txt ? this.Yiform.goods_mark_txt : "",
									// description: this.Addday.description,
									description: this.Addday.description ? this.Addday.description : "全站免费看",
								};
								let index = Session.get('indexArr');
								this.CZTwo[index] = ar;
								this.dialogVisible = false;
								this.show = 0;
							}
						} else {
							if (this.show == 2) {

								let index = Session.get('indexArrDanTwo');
								let objarDan = {
									...this.Yiform,
								};
								this.DanjuListTwo[index] = objarDan
								this.dialogVisible = false;
								this.show = 0;
							} else {
								this.DanjuListTwo.push(this.Yiform)
								this.dialogVisible = false;
								this.show = 0;
							}

						}
					}
				});
			}
		},

		onSubmit() {
			console.log(this.id,'是编辑还是保存')
			const mergedArray = this.CZOne.concat(this.DanjuList);
			const mergedArray2 = this.CZTwo.concat(this.DanjuListTwo);
			const formData = {
				...this.form,

				recharge_gear: JSON.stringify(mergedArray), // 将VIP天数添加到表单数据中
				w_recharge_gear: JSON.stringify(mergedArray2), // 将VIP天数添加到表单数据中
				// 其他表单项根据需要添加
			};

			if (formData.is_open == 0) {
				const { w_recharge_gear, ...formDataWithoutW } = this.form;
				const formDataY = {
					...formDataWithoutW,
					movie_id: this.mobanId,
					recharge_gear: JSON.stringify(mergedArray), // 将VIP天数添加到表单数据中
					// 其他表单项根据需要添加
				};
				if (mergedArray.length < 1) {
					this.$message.error('至少添加1个额度');
				} else {
					if(this.id)
				{
					const api = RechargeAPI();
					api.AddRecharge(formDataY).then((res) => {
						if (res.code == 0) {
							this.$message.success('保存成功');
							this.Getinfos();
							this.$emit('RechargeNone');
						} else {
							processErrors(res);
						}
					});
				}
				else
				{
					const api = RechargeAPI();
					api.AddRechargeStore(formDataY).then((res) => {
						if (res.code == 0) {
							this.$message.success('保存成功');
							this.Getinfos();
							this.$emit('RechargeNone');
						} else {
							processErrors(res);
						}
					});
				}
					
					
				}
			} else {
				if (mergedArray.length < 1 || this.CZTwo.length < 1) {
					this.$message.error('至少添加1个额度');
				} else {
					const api = RechargeAPI();
					api.AddRecharge(formData).then((res) => {
						if (res.code == 0) {
							this.$message.success('保存成功');
							this.$emit('RechargeNone');
						} else {
							processErrors(res);
						}
					});
				}
			}
		},
		handleOption(e) {
			this.Addday = this.YiformListAll.find((item) => item.id === e);

			this.Yiform.money = this.Addday.money;
			if (this.VIP_update) {
				this.Yiform.description = this.Addday.description;
			}
		},
		None() {
			this.Getinfos()
			// if(){

			// }
			this.form = {
				recharge_tag: 0,
				is_open: 1,
				platform_type: 1,
				w_recharge_gear: [], //未充值
				recharge_gear: [], //已充值
			};
			this.CZOne = []
			this.CZTwo = []
			this.DanjuList = []
			this.DanjuListTwo = []
		},
		handleSelectChange1(e){
			console.log(e,'选中哪个了')
		},
		handleSelectChange() {

			if (this.Yiform.recharge_type == 1) {
				this.$refs.ruleForm.resetFields();
				this.Yiform = {
					// day:"",
					recharge_type: 1, //是否是vip
					money: '', //充值金额
					free_balance: '', //赠送书币
					goods_mark_txt: '', //提示语
					footer_mark_txt: "",
					balance_all: "",
					balance: "",
					default_value:1
				}
				this.Addday.day = ""
				this.Addday.description = ""
				// (this.Yiform.money = ''), (this.Yiform.goods_mark_txt = '');
				// this.Yiform.free_balance = '';
				let params = {
					sort: 'money',
					sortType: 'asc',
				};
				const api = RechargeAPI();
				// api
				// 	.getvipList(params)
				// 	.then((res) => {
				// 		if (res.code == 0) {
				// 			// this.YiformList = res.data.data
				// 			this.YiformList = res.data.data.map((item) => ({
				// 				...item, // 保留原始对象的所有属性
				// 				customField: `${item.money}元 = ${item.day}天会员`, // 添加新的 customField 字段
				// 			}));
				// 			this.YiformListAll = res.data.data;
				// 		} else {
				// 			processErrors(res);
				// 		}
				// 	})
				// 	.catch((error) => {
				// 		this.loading = false;
				// 	});
			} else if (this.Yiform.recharge_type == 0) {
				this.$refs.ruleForm.resetFields();
				this.Yiform = {
					recharge_type: 0, //是否是vip
					money: '', //充值金额
					free_balance: '', //赠送书币
					goods_mark_txt: '', //提示语
					footer_mark_txt: "",
					balance_all: "",
					balance: "",
					default_value:1
				}
			} else {

			}
		},
		// handleClose(done) {
		// 	this.show=0
		// 	// done();
		// 	// this.$refs['ruleForm'].resetFields();
		// 	// this.Yiform = {
		// 	// 	recharge_type: 0, //是否是vip
		// 	// 	balance: 0, //充值金额
		// 	// 	free_balance: '', //赠送书币
		// 	// 	goods_mark_txt: '', //提示语
		// 	// };
		// },
		handleClose(done) {
			this.dialogVisible = false;
			this.show = 0
			this.$refs.ruleForm.resetFields();
			// done();
			// this.$refs['ruleForm'].resetFields();
			this.Yiform = {
				recharge_type: 0, //是否是vip
				money: '', //充值金额
				free_balance: '', //赠送书币
				goods_mark_txt: '', //提示语
				footer_mark_txt: "",
				balance_all: "",
				balance: ""
			}
		},
		//详情接口
		Getinfos() {
			const api = RechargeAPI();
			if (this.id != '') {
				api.goods_rechargeinfo(this.id).then((response) => {

					const type0And1 = response.data.recharge_gear.filter(item => item.recharge_type === 0 || item.recharge_type === 1);
					const type1 = response.data.recharge_gear.filter(item => item.recharge_type === 2);

					if (response.data.is_open == 0) {
						this.form.id = this.id;
						this.form.is_open = response.data.is_open;
						this.form = response.data;
						this.form.recharge_tag = response.data.recharge_tag;
						this.CZOne = type0And1;
						this.DanjuList = type1;
					} else {
						const type0And2 = response.data.w_recharge_gear.filter(item => item.recharge_type === 0 || item.recharge_type === 1);
						const type2 = response.data.w_recharge_gear.filter(item => item.recharge_type === 2);
						this.form.id = this.id;
						this.form = response.data;
						this.form.is_open = response.data.is_open;
						this.form.recharge_tag = response.data.recharge_tag;
						this.CZOne = type0And1;
						this.DanjuList = type1;
						this.DanjuListTwo = type2;
						this.CZTwo = type0And2;
					}
				});
			}
		},
	},
	created() { },
	mounted() {
		this.Getinfos();
		// this.title =
		// 	'预览 -' +
		// 	'ID：' +
		// 	this.videoObj.id +
		// 	'- 剧名：' +
		// 	this.videoObj.name +
		// 	'- 原剧名：' +
		// 	this.videoObj.origin_name +
		// 	'- CP名：' +
		// 	this.videoObj.cp_name;
		// let api = WorksListAPI();
		// api.VideoList(this.videoObj.id).then((res) => {
		// 	if (res.code == 0) {
		// 		this.videoUrl = res.data[0].resource;
		// 		this.videoList = res.data;
		// 	}
		// });
		// this.getSelect();
		// this.form.movie_id = this.paramsMovie.movie_id;
		if (!this.$route.query.key) {
			this.localParamsMovie = {};
		}
		this.mobanId = this.$route.query.key;
	},
};
</script>
<style lang="scss" scoped>
.Box {

	.Left {
		width: 60%;
		height: 100%;
		position: relative;

		.text {
			font-size: 14px;
		}

		.item {
			margin-bottom: 18px;
		}

		.clearfix:before,
		.clearfix:after {
			display: table;
			content: '';
		}

		.clearfix:after {
			clear: both;
		}

		.box-card {
			width: 380px;
			margin-left: 50px;

			.btn {
				width: 100%;
				height: 30px;
				background-color: #1890ff;
				color: #fff;
				border-radius: 32px;
				margin-top: 10px;
				line-height: 30px;
				text-align: center;
			}

			.btnAdDanju {
				width: 337px;
				height: 70px;
				border: #ccc 1px solid;
				border-radius: 10px;
				margin-top: 10px;
				text-align: center;
				line-height: 70px;

				// i {
				// 	font-size: 23px;
				// }
			}

			.btnAdDanjuitem {
				padding: 0;
				display: flex;
				background-image: url('../../../../assets/微信图片_20240910174026.png');
				background-size: cover;
				// /* 使背景图覆盖整个容器 */
				background-position: center;
				// /* 背景图居中对齐 */
				background-repeat: no-repeat;
				/* 背景图不重复 */
				height: 100vh;
				/* 高度覆盖视口高度 */
				width: 337px;
				height: 70px;
				border: #ccc 1px solid;
				border-radius: 10px;
				position: relative;
				overflow: hidden;

				.left {
					 display: flex;
					// flex-direction: column;
					width: 230px;
					// height: 80px;
					// line-height: 70px;
					text-align: center;
					align-items: center;
					// line-height: 30px;
					margin-left: 5px;
					justify-content: center;
				}

				.right {
					width: 100px;
					line-height: 70px;
					text-align: center;
					color: #e44663;

					span {
						font-size: 18px;
						color: #e44663;
						text-align: center;
					}
				}

				.right_jiao {
					height: 10px;
					position: absolute;
					right: 0px;

					top: -20px;
					// width: 40px;
					font-size: 11px;

					.jiao {
						color: #fff;
						margin-top: 9px;
						padding: 2px 10px 2px 16px;
						background-color: #ed6e33;
						// width: 80px;
						text-align: center;
						height: 30px;
						border-bottom-left-radius: 20px;
					}
				}
			}

			.white-background {
				background-color: #fff;
				// color: #fff;
			}

			.black-background {

				background-color: white;
				background-image: url('../../../../assets/zhuan.png');
				background-size: cover;
				/* 使背景图覆盖整个容器 */
				background-position: center;
				/* 背景图居中对齐 */
				background-repeat: no-repeat;
				//  背景图不重复 
				height: 100vh;
			}

			.btnAd {
				width: 150px;
				height: 120px;
				// border: #ccc 1px solid;
				border-radius: 10px;
				margin-top: 10px;
				padding: 0px 0;

				.btnAd_wai {
					border-radius: 10px;
					width: 150px;
					height: 100px;

					.price {
						height: 20px;
						font-size: 15px;
						line-height: 60px;
						text-align: center;
						font-size: 18px;
						font-weight: bold;
					}

					.bi {
						font-size: 10px;
						margin-top: 10px;
						// margin-top: 6px;
						text-align: center;
					}

					.dingBtn {
						position: absolute;
						top: -30px;
						right: 0px;
						height: 20px;
						// width: 40px;
						background-color: antiquewhite;
						line-height: 18px;
						text-align: center;
						padding: 2px 6px;
						background-color: #1890ff;
						color: #fff;
						border: 1px solid #ed6e33;
						border-top-right-radius: 7px;
						border-bottom-left-radius: 10px;
						font-size: 11px;
					}

					.song {
						margin: auto;
						width: 100%;
						line-height: 29px;
						text-align: center;
						font-size: 13px;
						margin-top: 2px;
						background-color: #1890ff;
						// border-radius: 10px;
						color: #fff;
						border-bottom-left-radius: 10px;
						border-bottom-right-radius: 10px;
					}
				}

			}

			.btnAds {
				width: 150px;
				height: 110px;
				border: #ccc 1px solid;
				border-radius: 10px;
				margin-top: 10px;
				text-align: center;
				line-height: 110px;

				i {
					font-size: 23px;
				}
			}
		}
	}

	.waiAdd {
		width: 80%;
		height: 100%;
		margin: auto;
	}
}

.el-card__body {
	padding: 0px !important;
}

.btn_left {
	margin-left: 100px;
}

.div_buttom {
	width: 100%;
	height: 30px;
	// display: flex;
	margin-bottom: 20px;
}
</style>
